// Cookie functions
export function setCookie (cname, cvalue, exdays, path) {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString()
  document.cookie =
    cname + '=' + cvalue + ';' + expires + ';path=/' + path + ';'
}

export function setCookieShareSubdomains(cname, cvalue, exdays, path, shareSubdomains) {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString()
  const { host } = location
  if (host.split('.').length === 1 || !shareSubdomains) {
    // no "." in a domain - it's localhost or something similar
    document.cookie = `${cname}=${cvalue};${expires};path=/${path}`
    // debugger
    console.debug('!shareSubdomains')
  } else {
    const domainParts = host.split('.')
    domainParts.shift()
    let domain = '.' + domainParts.join('.')

    document.cookie = `${cname}=${cvalue};${expires};path=/${path};domain=${domain}`
    console.debug('shareSubdomains')
    // debugger
  }
}

export function getCookie (cname) {
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }

    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }

  return ''
}

export function deleteCookie (name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;'
}

export function bake_cookie (name, value, exdays) {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString()
  const cookie = [
    name,
    '=',
    JSON.stringify(value),
    ';',
    expires,
    '; path=/;'
  ].join('')
  document.cookie = cookie
}

export function read_cookie (name) {
  let result = document.cookie.match(new RegExp(name + '=([^;]+)'))
  result && (result = JSON.parse(result[1]))
  return result
}

export function delete_cookie (name) {
  document.cookie = [
    name,
    '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/; domain=.',
    window.location.host.toString()
  ].join('')
}

export function setCookieToPage (cvalue) {
  setCookie('choiceSeat', cvalue, 365, '')
}

export function eraseCookie (cname) {
  setCookie(cname, '', -1, '')
}


export function setCookieMins (cname, cvalue, exmins, path) {
  var d = new Date()
  d.setTime(d.getTime() + (exmins * 60 * 1000))
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/' + path + ';'
}

window.delete_cookie = delete_cookie
